import horiLogo from '../../assets/images/horiLogo.png';
import microsoftExcel from '../../assets/images/microsoftExcel.png';
import veriLogo from '../../assets/images/vertiLogo.jpeg';
import enflag from '../../assets/images/flags/en.svg';
import deflag from '../../assets/images/flags/de.svg';
import esflag from '../../assets/images/flags/es.svg';
import hiflag from '../../assets/images/flags/hi.svg';
import AugmentLogo from '../../assets/images/paypromptLogo.svg';
import AugmentLogoSmall from '../../assets/images/paypromptLogoSmall.svg';
import PaypromtLogo from '../../assets/images/augmentNewLogo.png';
import LoadingGif from '../../assets/gifs/loading.gif';
import fileUploadIcon from '../../assets/images/fileUploadIcon.png';
import leftArrow from '../../assets/images/leftArrow.png';
import rightArrow from '../../assets/images/rightArrow.png';
import loaderGif from '../../assets/gifs/loader.gif';

export default function imageFlag(type) {
  let flag;
  switch (type) {
    case 'de':
      flag = deflag;
      break;
    case 'es':
      flag = esflag;
      break;
    case 'hi':
      flag = hiflag;
      break;
    default:
      flag = enflag;
  }

  return flag;
}

export const Images = {
  horiLogo,
  veriLogo,
  microsoftExcel,
  AugmentLogo,
  AugmentLogoSmall,
  PaypromtLogo,
  LoadingGif,
  fileUploadIcon,
  leftArrow,
  rightArrow,
  loaderGif,
};
